// import React, { useState } from 'react';
// import axios from 'axios';
// import './VideoLinkManagement.css';

// const API_URL = 'https://apitop.topranohotelandlounge.com';

// function VideoLinkManagement({ videoLinks, onUpdate }) {
//   const [editing, setEditing] = useState(null);
//   const [isCreating, setIsCreating] = useState(false);
//   const [formData, setFormData] = useState({
//     id: '',
//     description: '',
//     video: null,
//     thumbnail: null,
//     videoUrl: '',
//     thumbnailUrl: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   // Start creating a new video link
//   const startCreating = () => {
//     setIsCreating(true);
//     setEditing(null);
//     setFormData({
//       id: '',
//       description: '',
//       video: null,
//       thumbnail: null,
//       videoUrl: '',
//       thumbnailUrl: ''
//     });
//     setMessage(null);
//     setError(null);
//   };

//   // Start editing
//   const startEditing = (link) => {
//     setEditing(link._id);
//     setIsCreating(false);
//     setFormData({
//       id: link.id,
//       description: link.description,
//       video: null,
//       thumbnail: null,
//       videoUrl: link.video || '',
//       thumbnailUrl: link.thumbnail || ''
//     });
//     setMessage(null);
//     setError(null);
//   };

//   // Cancel editing/creating
//   const cancel = () => {
//     setEditing(null);
//     setIsCreating(false);
//     setFormData({ id: '', description: '', video: null, thumbnail: null, videoUrl: '', thumbnailUrl: '' });
//     setMessage(null);
//     setError(null);
//   };

//   // Handle change
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: files ? files[0] : value
//     }));
//   };

//   // Handle create
//   const handleCreate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);
//     setError(null);

//     try {
//       const fd = new FormData();
//       fd.append('id', formData.id);
//       fd.append('description', formData.description);
//       if (formData.video) fd.append('videoFile', formData.video);
//       if (formData.thumbnail) fd.append('thumbnail', formData.thumbnail);

//       await axios.post(`${API_URL}/api/videolinks`, fd, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//       setMessage('Video link created successfully! ✅');
//       onUpdate();
//       cancel();
//     } catch (err) {
//       console.error('Error creating video link:', err.response?.data || err.message);
//       setError(err.response?.data?.error || 'Failed to create video link. Please try again. ❌');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle update
//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);
//     setError(null);

//     try {
//       const fd = new FormData();
//       fd.append('id', formData.id);
//       fd.append('description', formData.description);
//       if (formData.video) fd.append('videoFile', formData.video);
//       if (formData.thumbnail) fd.append('thumbnail', formData.thumbnail);

//       // Use the MongoDB _id for updates, not the custom id
//       await axios.put(`${API_URL}/api/videolinks/${editing}`, fd, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//       setMessage('Video link updated successfully! ✅');
//       onUpdate();
//       cancel();
//     } catch (err) {
//       console.error('Error updating video link:', err.response?.data || err.message);
//       setError(err.response?.data?.error || 'Failed to update video link. Please try again. ❌');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete
//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this video link?')) return;
//     try {
//       // Use the MongoDB _id for deletion
//       await axios.delete(`${API_URL}/api/videolinks/${id}`);
//       setMessage('Video link deleted successfully! ✅');
//       onUpdate();
//     } catch (err) {
//       console.error('Error deleting video link:', err.response?.data || err.message);
//       setError(err.response?.data?.error || 'Failed to delete video link. Please try again. ❌');
//     }
//   };

//   return (
//     <div className="video-management bg-gray-100 p-6 rounded-lg shadow-md">
//       {message && <div className="alert alert-success mb-4">{message}</div>}
//       {error && <div className="alert alert-error mb-4">{error}</div>}
      
//       <div className="flex justify-between items-center mb-6">
//         <h2 className="list-title text-2xl font-bold text-blue-900">
//           Manage Video Links ({videoLinks.length})
//         </h2>
//         <button
//           onClick={startCreating}
//           className="btn btn-primary text-sm px-4 py-2"
//         >
//           + Add New Video Link
//         </button>
//       </div>
      
//       <div className="list-container space-y-4">
//         {videoLinks.length === 0 ? (
//           <p className="text-center text-gray-600">No video links found.</p>
//         ) : (
//           videoLinks.map((link) => (
//             <div key={link._id} className="list-item bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
//               <div className="list-item-header flex justify-between items-center">
//                 <h3 className="list-item-title text-lg font-semibold text-gray-800">{link.id}</h3>
//                 <div className="list-item-actions flex gap-2">
//                   <button
//                     onClick={() => startEditing(link)}
//                     className="btn btn-primary text-sm px-4 py-2"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => handleDelete(link._id)} // Use MongoDB _id for deletion
//                     className="btn btn-danger text-sm px-4 py-2"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//               <p className="list-item-content text-gray-600 mt-2">{link.description.substring(0, 150)}...</p>
//               <div className="list-item-media flex gap-4 mt-2">
//                 <video
//                   src={`${API_URL}${link.video}`}
//                   poster={link.thumbnail ? `${API_URL}${link.thumbnail}` : undefined}
//                   className="w-1/2 h-20 rounded-md"
//                   controls
//                 />
//                 {link.thumbnail && (
//                   <img
//                     src={`${API_URL}${link.thumbnail}`}
//                     alt={link.id}
//                     className="w-1/4 h-24 rounded-md shadow-sm"
//                   />
//                 )}
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {(editing || isCreating) && (
//         <div className="admin-form bg-white p-6 mt-6 rounded-lg shadow-md">
//           <h3 className="form-title text-xl font-bold text-blue-900 mb-4">
//             {isCreating ? 'Create New Video Link' : 'Edit Video Link'}
//           </h3>
//           <form onSubmit={isCreating ? handleCreate : handleUpdate} className="form-container space-y-4">
//             <div className="form-grid grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div className="form-group">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">ID</label>
//                 <input
//                   type="text"
//                   name="id"
//                   value={formData.id}
//                   onChange={handleChange}
//                   className="form-input w-full p-3 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200"
//                   required
//                 />
//               </div>
//               <div className="form-group">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   {isCreating ? 'Video File' : 'Current Video URL'}
//                 </label>
//                 {!isCreating && (
//                   <>
//                     <input
//                       type="text"
//                       name="videoUrl"
//                       value={formData.videoUrl}
//                       onChange={handleChange}
//                       className="form-input w-full p-3 border border-gray-300 rounded-md bg-gray-100 mb-2"
//                       readOnly
//                     />
//                     <label className="block text-sm font-medium text-gray-700 mb-1">New Video File (optional)</label>
//                   </>
//                 )}
//                 <input
//                   type="file"
//                   name="video"
//                   accept="video/*"
//                   onChange={handleChange}
//                   className="form-input w-full p-3 border border-gray-300 rounded-md"
//                   required={isCreating}
//                 />
//                 {formData.video && (
//                   <p className="text-sm text-gray-600 mt-1">Selected: {formData.video.name}</p>
//                 )}
//               </div>
//               <div className="form-group">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   {isCreating ? 'Thumbnail Image' : 'Current Thumbnail URL'}
//                 </label>
//                 {!isCreating && (
//                   <>
//                     <input
//                       type="text"
//                       name="thumbnailUrl"
//                       value={formData.thumbnailUrl}
//                       onChange={handleChange}
//                       className="form-input w-full p-3 border border-gray-300 rounded-md bg-gray-100 mb-2"
//                       readOnly
//                     />
//                     <label className="block text-sm font-medium text-gray-700 mb-1">New Thumbnail (optional)</label>
//                   </>
//                 )}
//                 <input
//                   type="file"
//                   name="thumbnail"
//                   accept="image/*"
//                   onChange={handleChange}
//                   className="form-input w-full p-3 border border-gray-300 rounded-md"
//                 />
//                 {formData.thumbnail && (
//                   <p className="text-sm text-gray-600 mt-1">Selected: {formData.thumbnail.name}</p>
//                 )}
//               </div>
//             </div>
//             <div className="form-group">
//               <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
//               <textarea
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 className="form-textarea w-full p-3 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 min-h-[100px]"
//                 required
//               />
//             </div>
//             {!isCreating && formData.videoUrl && (
//               <div className="form-group">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Current Video Preview</label>
//                 <video
//                   src={`${API_URL}${formData.videoUrl}`}
//                   poster={formData.thumbnailUrl ? `${API_URL}${formData.thumbnailUrl}` : undefined}
//                   className="w-full h-64 rounded-md"
//                   controls
//                 />
//               </div>
//             )}
//             {!isCreating && formData.thumbnailUrl && (
//               <div className="form-group">
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Current Thumbnail Preview</label>
//                 <img
//                   src={`${API_URL}${formData.thumbnailUrl}`}
//                   alt="Thumbnail Preview"
//                   className="w-1/4 h-24 rounded-md shadow-sm"
//                 />
//               </div>
//             )}
//             <div className="form-buttons flex gap-3">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="btn btn-primary px-6 py-3"
//               >
//                 {loading ? 'Saving...' : (isCreating ? 'Create Video Link' : 'Save Changes')}
//               </button>
//               <button
//                 type="button"
//                 onClick={cancel}
//                 className="btn btn-secondary px-6 py-3"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//     </div>
//   );
// }

// export default VideoLinkManagement;


// import React, { useState } from 'react';
// import axios from 'axios';
// import './VideoLinkManagement.css';

// const API_URL = 'http://localhost:8001';

// function VideoLinkManagement({ videoLinks, onUpdate }) {
//   const [editing, setEditing] = useState(null);
//   const [isCreating, setIsCreating] = useState(false);
//   const [formData, setFormData] = useState({
//     id: '',
//     description: '',
//     video: null,
//     thumbnail: null,
//     videoUrl: '',
//     thumbnailUrl: ''
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);
//   const [error, setError] = useState(null);

//   // Start creating a new video link
//   const startCreating = () => {
//     setIsCreating(true);
//     setEditing(null);
//     setFormData({
//       id: '',
//       description: '',
//       video: null,
//       thumbnail: null,
//       videoUrl: '',
//       thumbnailUrl: ''
//     });
//     setMessage(null);
//     setError(null);
//   };

//   // Start editing
//   const startEditing = (link) => {
//     setEditing(link._id);
//     setIsCreating(false);
//     setFormData({
//       id: link.id,
//       description: link.description,
//       video: null,
//       thumbnail: null,
//       videoUrl: link.video || '',
//       thumbnailUrl: link.thumbnail || ''
//     });
//     setMessage(null);
//     setError(null);
//   };

//   // Cancel editing/creating
//   const cancel = () => {
//     setEditing(null);
//     setIsCreating(false);
//     setFormData({ id: '', description: '', video: null, thumbnail: null, videoUrl: '', thumbnailUrl: '' });
//     setMessage(null);
//     setError(null);
//   };

//   // Handle change
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: files ? files[0] : value
//     }));
//   };

//   // Handle create
//   const handleCreate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);
//     setError(null);

//     try {
//       const fd = new FormData();
//       fd.append('id', formData.id);
//       fd.append('description', formData.description);
//       if (formData.video) fd.append('videoFile', formData.video);
//       if (formData.thumbnail) fd.append('thumbnail', formData.thumbnail);

//       await axios.post(`${API_URL}/api/videolinks`, fd, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//       setMessage('Video link created successfully!');
//       onUpdate();
//       cancel();
//     } catch (err) {
//       console.error('Error creating video link:', err.response?.data || err.message);
//       setError(err.response?.data?.error || 'Failed to create video link. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle update
//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage(null);
//     setError(null);

//     try {
//       const fd = new FormData();
//       fd.append('id', formData.id);
//       fd.append('description', formData.description);
//       if (formData.video) fd.append('videoFile', formData.video);
//       if (formData.thumbnail) fd.append('thumbnail', formData.thumbnail);

//       // Use the MongoDB _id for updates, not the custom id
//       await axios.put(`${API_URL}/api/videolinks/${editing}`, fd, {
//         headers: { 'Content-Type': 'multipart/form-data' }
//       });
//       setMessage('Video link updated successfully!');
//       onUpdate();
//       cancel();
//     } catch (err) {
//       console.error('Error updating video link:', err.response?.data || err.message);
//       setError(err.response?.data?.error || 'Failed to update video link. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Delete
//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this video link?')) return;
//     try {
//       // Use the MongoDB _id for deletion
//       await axios.delete(`${API_URL}/api/videolinks/${id}`);
//       setMessage('Video link deleted successfully!');
//       onUpdate();
//     } catch (err) {
//       console.error('Error deleting video link:', err.response?.data || err.message);
//       setError(err.response?.data?.error || 'Failed to delete video link. Please try again.');
//     }
//   };

//   return (
//     <div className="video-management">
//       {message && <div className="alert alert-success">{message}</div>}
//       {error && <div className="alert alert-error">{error}</div>}
      
//       <div className="management-header">
//         <h2 className="list-title">
//           Manage Video Links ({videoLinks.length})
//         </h2>
//         <button
//           onClick={startCreating}
//           className="btn btn-primary"
//         >
//           + Add New Video Link
//         </button>
//       </div>
      
//       <div className="list-container">
//         {videoLinks.length === 0 ? (
//           <div className="empty-state">
//             <p>No video links found.</p>
//           </div>
//         ) : (
//           videoLinks.map((link) => (
//             <div key={link._id} className="list-item">
//               <div className="list-item-header">
//                 <h3 className="list-item-title">{link.id}</h3>
//                 <div className="list-item-actions">
//                   <button
//                     onClick={() => startEditing(link)}
//                     className="btn btn-primary"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => handleDelete(link._id)} // Use MongoDB _id for deletion
//                     className="btn btn-danger"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//               <p className="list-item-content">{link.description.substring(0, 150)}...</p>
//               <div className="list-item-media">
//                 <video
//                   src={`${API_URL}${link.video}`}
//                   poster={link.thumbnail ? `${API_URL}${link.thumbnail}` : undefined}
//                   className="video-preview"
//                   controls
//                 />
//                 {link.thumbnail && (
//                   <img
//                     src={`${API_URL}${link.thumbnail}`}
//                     alt={link.id}
//                     className="thumbnail-preview"
//                   />
//                 )}
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {(editing || isCreating) && (
//         <div className="admin-form">
//           <h3 className="form-title">
//             {isCreating ? 'Create New Video Link' : 'Edit Video Link'}
//           </h3>
//           <form onSubmit={isCreating ? handleCreate : handleUpdate} className="form-container">
//             <div className="form-grid">
//               <div className="form-group">
//                 <label className="form-label">ID</label>
//                 <input
//                   type="text"
//                   name="id"
//                   value={formData.id}
//                   onChange={handleChange}
//                   className="form-input"
//                   required
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label className="form-label">
//                   {isCreating ? 'Video File' : 'Current Video URL'}
//                 </label>
//                 {!isCreating && (
//                   <>
//                     <input
//                       type="text"
//                       name="videoUrl"
//                       value={formData.videoUrl}
//                       onChange={handleChange}
//                       className="form-input readonly"
//                       readOnly
//                     />
//                     <label className="form-label">New Video File (optional)</label>
//                   </>
//                 )}
//                 <input
//                   type="file"
//                   name="video"
//                   accept="video/*"
//                   onChange={handleChange}
//                   className="form-input-file"
//                   required={isCreating}
//                 />
//                 {formData.video && (
//                   <p className="file-selected">Selected: {formData.video.name}</p>
//                 )}
//               </div>
              
//               <div className="form-group">
//                 <label className="form-label">
//                   {isCreating ? 'Thumbnail Image' : 'Current Thumbnail URL'}
//                 </label>
//                 {!isCreating && (
//                   <>
//                     <input
//                       type="text"
//                       name="thumbnailUrl"
//                       value={formData.thumbnailUrl}
//                       onChange={handleChange}
//                       className="form-input readonly"
//                       readOnly
//                     />
//                     <label className="form-label">New Thumbnail (optional)</label>
//                   </>
//                 )}
//                 <input
//                   type="file"
//                   name="thumbnail"
//                   accept="image/*"
//                   onChange={handleChange}
//                   className="form-input-file"
//                 />
//                 {formData.thumbnail && (
//                   <p className="file-selected">Selected: {formData.thumbnail.name}</p>
//                 )}
//               </div>
//             </div>
            
//             <div className="form-group">
//               <label className="form-label">Description</label>
//               <textarea
//                 name="description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 className="form-textarea"
//                 required
//               />
//             </div>
            
//             {!isCreating && formData.videoUrl && (
//               <div className="form-group">
//                 <label className="form-label">Current Video Preview</label>
//                 <video
//                   src={`${API_URL}${formData.videoUrl}`}
//                   poster={formData.thumbnailUrl ? `${API_URL}${formData.thumbnailUrl}` : undefined}
//                   className="video-preview-large"
//                   controls
//                 />
//               </div>
//             )}
            
//             {!isCreating && formData.thumbnailUrl && (
//               <div className="form-group">
//                 <label className="form-label">Current Thumbnail Preview</label>
//                 <img
//                   src={`${API_URL}${formData.thumbnailUrl}`}
//                   alt="Thumbnail Preview"
//                   className="thumbnail-preview-large"
//                 />
//               </div>
//             )}
            
//             <div className="form-buttons">
//               <button
//                 type="submit"
//                 disabled={loading}
//                 className="btn btn-primary"
//               >
//                 {loading ? 'Saving...' : (isCreating ? 'Create Video Link' : 'Save Changes')}
//               </button>
//               <button
//                 type="button"
//                 onClick={cancel}
//                 className="btn btn-secondary"
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       )}
//     </div>
//   );
// }

// export default VideoLinkManagement;

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './VideoLinkManagement.css';

const API_URL = 'https://apipurple.topranohotelandlounge.com';

function VideoLinkManagement() {
  const [videoLinks, setVideoLinks] = useState([]);
  const [latestVideoLink, setLatestVideoLink] = useState(null);
  const [editing, setEditing] = useState(null);
  const [isCreating, setIsCreating] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    description: '',
    video: '',
    thumbnail: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // Fetch all video links
  const fetchVideoLinks = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/videoslinks`);
      setVideoLinks(response.data.data || []);
    } catch (err) {
      console.error('Error fetching video links:', err);
      setVideoLinks([]);
    }
  };

  // Fetch latest video link
  const fetchLatestVideoLink = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/videoslinks/latest`);
      setLatestVideoLink(response.data.data);
    } catch (err) {
      console.error('Error fetching latest video link:', err);
      setLatestVideoLink(null);
    }
  };

  // Refresh data
  const refreshData = () => {
    fetchVideoLinks();
    fetchLatestVideoLink();
  };

  // Load data on component mount
  useEffect(() => {
    refreshData();
  }, []);

  // Start creating a new video link
  const startCreating = () => {
    setIsCreating(true);
    setEditing(null);
    setFormData({
      id: '',
      description: '',
      video: '',
      thumbnail: ''
    });
    setMessage(null);
    setError(null);
  };

  // Start editing
  const startEditing = (link) => {
    setEditing(link._id);
    setIsCreating(false);
    setFormData({
      id: link.id,
      description: link.description,
      video: link.video || '',
      thumbnail: link.thumbnail || ''
    });
    setMessage(null);
    setError(null);
  };

  // Cancel editing/creating
  const cancel = () => {
    setEditing(null);
    setIsCreating(false);
    setFormData({ 
      id: '', 
      description: '', 
      video: '', 
      thumbnail: '' 
    });
    setMessage(null);
    setError(null);
  };

  // Handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle create
  const handleCreate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      await axios.post(`${API_URL}/api/videoslinks`, formData);
      setMessage('Video link created successfully!');
      refreshData();
      cancel();
    } catch (err) {
      console.error('Error creating video link:', err.response?.data || err.message);
      setError(err.response?.data?.message || 'Failed to create video link. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  // Handle update
const handleUpdate = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage(null);
  setError(null);

  try {
    const linkToUpdate = videoLinks.find(link => link._id === editing);
    if (!linkToUpdate) {
      throw new Error('Video link not found');
    }

    // Create update data WITHOUT the id field
    const updateData = {
      description: formData.description,
      video: formData.video,
      thumbnail: formData.thumbnail
    };

    await axios.put(`${API_URL}/api/videoslinks/${linkToUpdate.id}`, updateData);
    setMessage('Video link updated successfully!');
    refreshData();
    cancel();
  } catch (err) {
    console.error('Error updating video link:', err.response?.data || err.message);
    setError(err.response?.data?.message || 'Failed to update video link. Please try again.');
  } finally {
    setLoading(false);
  }
};
  // Delete
  const handleDelete = async (link) => {
    if (!window.confirm('Are you sure you want to delete this video link?')) return;
    try {
      await axios.delete(`${API_URL}/api/videoslinks/${link.id}`);
      setMessage('Video link deleted successfully!');
      refreshData();
    } catch (err) {
      console.error('Error deleting video link:', err.response?.data || err.message);
      setError(err.response?.data?.message || 'Failed to delete video link. Please try again.');
    }
  };

  return (
    <div className="video-management">
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-error">{error}</div>}
      
      {/* Latest Video Link Section */}
      <div className="latest-video-section">
        <h2 className="section-title">Latest Video</h2>
        {latestVideoLink ? (
          <div className="latest-video-card">
            <h3>{latestVideoLink.id}</h3>
            <p>{latestVideoLink.description}</p>
            {latestVideoLink.video && (
              <video
                src={latestVideoLink.video}
                poster={latestVideoLink.thumbnail || undefined}
                className="latest-video-player"
                controls
              />
            )}
            {latestVideoLink.thumbnail && !latestVideoLink.video && (
              <img
                src={latestVideoLink.thumbnail}
                alt={latestVideoLink.id}
                className="latest-thumbnail"
              />
            )}
          </div>
        ) : (
          <div className="empty-state">
            <p>No video links available</p>
          </div>
        )}
      </div>

      {/* Management Section */}
      <div className="management-header">
        <h2 className="list-title">
          Manage Video Links ({videoLinks.length})
        </h2>
        <button
          onClick={startCreating}
          className="btn btn-primary"
        >
          + Add New Video Link
        </button>
      </div>
      
      <div className="list-container">
        {videoLinks.length === 0 ? (
          <div className="empty-state">
            <p>No video links found.</p>
          </div>
        ) : (
          videoLinks.map((link) => (
            <div key={link._id} className="list-item">
              <div className="list-item-header">
                <h3 className="list-item-title">{link.id}</h3>
                <div className="list-item-actions">
                  <button
                    onClick={() => startEditing(link)}
                    className="btn btn-primary"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(link)}
                    className="btn btn-danger"
                  >
                    Delete
                  </button>
                </div>
              </div>
              <p className="list-item-content">{link.description}</p>
              <div className="list-item-media">
                {link.video && (
                  <video
                    src={link.video}
                    poster={link.thumbnail || undefined}
                    className="video-preview"
                    controls
                  />
                )}
                {link.thumbnail && !link.video && (
                  <img
                    src={link.thumbnail}
                    alt={link.id}
                    className="thumbnail-preview"
                  />
                )}
                <div className="url-display">
                  {link.video && (
                    <div className="url-item">
                      <strong>Video URL:</strong> 
                      <a href={link.video} target="_blank" rel="noopener noreferrer" className="url-link">
                        {link.video}
                      </a>
                    </div>
                  )}
                  {link.thumbnail && (
                    <div className="url-item">
                      <strong>Thumbnail URL:</strong> 
                      <a href={link.thumbnail} target="_blank" rel="noopener noreferrer" className="url-link">
                        {link.thumbnail}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Form for creating/editing */}
      {(editing || isCreating) && (
        <div className="admin-form">
          <h3 className="form-title">
            {isCreating ? 'Create New Video Link' : 'Edit Video Link'}
          </h3>
          <form onSubmit={isCreating ? handleCreate : handleUpdate} className="form-container">
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">ID *</label>
                <input
                  type="text"
                  name="id"
                  value={formData.id}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Enter unique ID (e.g., tutorial-1)"
                  required
                  disabled={!isCreating}
                />
                {!isCreating && (
                  <small className="form-help">ID cannot be changed after creation</small>
                )}
              </div>
              
              <div className="form-group">
                <label className="form-label">Video URL *</label>
                <input
                  type="url"
                  name="video"
                  value={formData.video}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="https://example.com/video.mp4"
                  required
                />
                <small className="form-help">Enter the full URL to your video file</small>
              </div>
              
              <div className="form-group">
                <label className="form-label">Thumbnail URL</label>
                <input
                  type="url"
                  name="thumbnail"
                  value={formData.thumbnail}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="https://example.com/thumbnail.jpg"
                />
                <small className="form-help">Enter the full URL to your thumbnail image</small>
              </div>
            </div>
            
            <div className="form-group">
              <label className="form-label">Description *</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                className="form-textarea"
                placeholder="Enter description for this video link..."
                required
                rows="4"
              />
            </div>
            
            {formData.video && (
              <div className="form-group">
                <label className="form-label">Video Preview</label>
                <video
                  src={formData.video}
                  poster={formData.thumbnail || undefined}
                  className="video-preview-large"
                  controls
                />
              </div>
            )}
            
            {formData.thumbnail && (
              <div className="form-group">
                <label className="form-label">Thumbnail Preview</label>
                <img
                  src={formData.thumbnail}
                  alt="Thumbnail Preview"
                  className="thumbnail-preview-large"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            )}
            
            <div className="form-buttons">
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary"
              >
                {loading ? 'Saving...' : (isCreating ? 'Create Video Link' : 'Save Changes')}
              </button>
              <button
                type="button"
                onClick={cancel}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default VideoLinkManagement;


  // Handle update
  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setMessage(null);
  //   setError(null);

  //   try {
  //     const linkToUpdate = videoLinks.find(link => link._id === editing);
  //     if (!linkToUpdate) {
  //       throw new Error('Video link not found');
  //     }

  //     await axios.put(`${API_URL}/api/videolinks/${linkToUpdate.id}`, formData);
  //     setMessage('Video link updated successfully!');
  //     refreshData();
  //     cancel();
  //   } catch (err) {
  //     console.error('Error updating video link:', err.response?.data || err.message);
  //     setError(err.response?.data?.message || 'Failed to update video link. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };
